import {
  Mixins,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/set';
import publicApi from '@/api/public';
import pageMixin from '../../../../mixins/pageMixin';


@Component
export default class tableMixin extends Mixins(pageMixin) {

  private courseHourdatas: any = [];

  private searchData: any = []

  public form: any = {}; // 表格行数据

  public column: Array<ITABLECOLCONF> = [{
    label: '课程名称',
    prop: 'title',
    align: 'center',
  },
  {
    label: '授课方式',
    prop: 'learningType',
    align: 'center',
    custom: true,
    tags: [{
      value: '0',
      type: 'success',
      label: '线下',
    }, {
      value: '1',
      type: 'danger',
      label: '线上',
    }],
  },
    {
      label: '开班形式',
      prop: 'learningNum',
      align: 'center',
      custom: true,
      tags: [{
        value: '0',
        type: 'info',
        label: '1对1',
      }, {
        value: '1',
        type: '',
        label: '1对多',
      },{
        value: '2',
        type: 'warning',
        label: '无限制',
      }],
    },
  {
    label: '授课时长',
    align: 'center',
    prop: 'learningTime',
  }, {
    label: '标准课时',
    align: 'center',
    prop: 'standardHour',
  }, {
    label: '创建时间',
    prop: 'createAt',
    align: 'center',
  },{
    label: '更新时间',
    prop: 'updateAt',
    align: 'center',
  },
  {
    label: '操作',
    custom: true,
    minWidth: '120',
    maxBtn: 2,
    btnList: [
      {
        title: '编辑',
        name: '/set/course:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleUpdateForm,
        log: {
          name: '系统配置 - 编辑',
          component: 'set/tableMixin',
        },
      },
      {
        title: '删除',
        name: '/set/course:delete',
        icon: 'remove',
        type: 'info',
        callback: this.handleRmove,
        log: {
          name: '系统配置 - 删除',
          component: 'set/tableMixin',
        },
      },
    ],
    align: 'center',
  }];

  private loading: boolean = true;

  mounted() {
    this.getData();
  }

  /* eslint-disable class-methods-use-this */
  /**
   * @desc 获取配置列表
   */
  getData(title: String = '') {
    this.loading = true
    api.getCourseHours(title).then((res: any) => {
      this.courseHourdatas = res
      this.loading = false
    })
  }

  handleUpdateForm(row) {}


  /**
   * @author ruixue
   * @desc 删除配置操作
   * @param { any } row 行数据
  */
  handleRmove(row: any) {
    this.confirm('此操作将永久删除该数据, 是否继续?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeCourseConfig(row.id).then(() => {
        close();
        this.getData();
        this.$log({
          title: '课时定义 - 删除 - 确定',
          component: 'course/components/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '课时定义 - 删除 - 取消',
      component: 'course/components/tableMixin',
    }));
  }
}
